import {Component, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {Input} from '@angular/core';
import {ProductService} from '../../../services/product.service';
import {Product, RootObject} from '../../../models/product';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {SlidesOutputData} from 'ngx-owl-carousel-o';
import {DataSetParams, ProductDataSet} from '../../../models/product-data-set';
import {SearchService} from '../../../services/search.service';
import {CustomerSearchService} from '../../../events/customer-search.service';
import {Wishlist} from '../../../models/Wishlist/Wishlist';
import {WishlistService} from '../../../services/wishlist.service';
import {AuthService} from '../../../../../services/auth.service';
import {RegistryService} from '../../../services/registry.service';
import {response} from 'express';

declare var $;

@Component({
    selector: 'app-product-slider',
    templateUrl: './product-slider.component.html',
    styleUrls: ['./product-slider.component.css']
})
export class ProductSliderComponent implements OnInit {

    @Input('sliderType') sliderType = 'category';
    @Input('categoryId') category_id = null;
    @Input('productSKU') product_sku = null;
    @Input('title') title = '';
    @Input('showInStockProducts') showInStockProducts : boolean = false;

    constructor(public productService: ProductService ,
                public registry: RegistryService,
                private wishlistService: WishlistService , private authService: AuthService) {


    }

    empty_products = null;
    Products: Product[] = [];
    parentProduct: any = [];
    previosPosition = 0;
    currentPosition = 0;
    catLen: any = [];
    page = 1;
    catId: number;
    URL = ' ';
    slidePerLoad = 8;
    blockPerSlide = 4;
    // wishList : Wishlist;
    // @Input() isCustomer : boolean;

    totalDataCount = 1000000;

    @Input() id: number;
    @Input() sku: string;
    @Input('ProductDataSet') ProductDataSet: ProductDataSet = new ProductDataSet();


    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        lazyLoad: true,
        margin: 10,
        dots: false,
        navSpeed: 200,
        nav: true,
        navText: ['<div class=\'nav-btn prev-slide  p-slider-arrow-left\'>' +
        '<i class=\'la la-chevron-circle-left\'></i></div>',
            '<div class=\'nav-btn next-slide p-slider-arrow-right\'><i class=\'la la-chevron-circle-right\'></i></div>'],
        // navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ],
        autoHeight: true,
        slideBy: '4',
        responsive: {
            0: {
                items: 1
            },
            100: {
                items: 1
            },
            440: {
                items: 2
            },
            740: {
                items: 3
            },
            900: {
                items: 5
            },
            1280: {
                items: 6
            }
        }
    };

    activeSlides: SlidesOutputData;

    test() {
        $( 'body' ).css( 'overflow', 'hidden' );
    }

    test2() {
        $( 'body' ).css( 'overflow', 'auto' );
    }

    loadNextProducts(data2: SlidesOutputData) {


        this.activeSlides = data2;
        this.customOptions.startPosition = this.activeSlides.startPosition;
        // this.previosPosition = this.currentPosition;
        this.currentPosition = data2.startPosition;


        if (((this.currentPosition % this.slidePerLoad) == 0) && (this.totalDataCount >= this.Products.length)) {
            // we have one buffered slide left, load new
            // if (this.currentPosition > this.previosPosition) {
            const params = this.ProductDataSet.getDataSetParams(this.registry.getWebsiteId());
            this.productService.getProductDataSet(params).subscribe((data: RootObject) => {
                const next_products = data.items.map(item => Object.assign(new Product(), item));
                next_products.forEach(e => {
                    this.Products.push(e);
                });
                this.totalDataCount = data.total_count;
                this.ProductDataSet.page = this.ProductDataSet.page + 1;

            });
        }


    }


    getProductRelatedProducts() {
        return this.productService.getProductDetails(this.product_sku).subscribe((product: Product) => {
            this.parentProduct = product;
            this.catLen = this.parentProduct.extension_attributes.category_links;
            this.catId = this.parentProduct.extension_attributes.category_links[this.catLen.length - 1].category_id;
            this.ProductDataSet.pushParams('category_id', this.catId, 'eq');
            this.fetchProductDataSet();

        });

    }



    fetchProductDataSet() {

        return this.productService.getProductDataSet(this.ProductDataSet.getDataSetParams(this.registry.getWebsiteId())).subscribe((data: any) => {
            // console.log('the url ' + url);
            this.Products = data.items.map(item => Object.assign(new Product(), item));

            if(this.showInStockProducts){
                const product_ids = this.Products.map(product => product.id);

                let obj = {
                    product_ids : product_ids.join(',')
                }

                let productsInStock = [];

                this.productService.getProductsInStock(obj).subscribe(response => {
                    // console.log('producInStockkkk' , response);
                    productsInStock = response;

                    let tempProducts = this.Products;
                    this.Products = [];

                    for(let i=0 ; i< tempProducts.length ; i++){
                        let index = productsInStock.findIndex(e => e.product_id == tempProducts[i].id && e.stock_status === 1);
                        if(index != -1){
                            this.Products.push(tempProducts[i]);
                        }
                    }

                    // console.log('finalProductssss' , this.Products);

                })




            }


            if (this.Products.length == 0) {
                this.empty_products = true;
            }

            this.ProductDataSet.page = this.ProductDataSet.page + 1;

        });




    }


    ngOnInit(): void {


        switch (this.sliderType) {
            case 'product_related':
                if (this.product_sku !== undefined) {
                    this.getProductRelatedProducts();
                }
                break;

            case 'category':
                this.ProductDataSet.clearParams();
                this.ProductDataSet.pushParams('category_id', this.category_id, 'eq');
                this.fetchProductDataSet();
                break;

            case 'dataset':
                if (this.ProductDataSet !== undefined) {
                    this.fetchProductDataSet();
                }
                break;
        }



        // if (this.sku !== undefined) {
        //     this.getProductRelatedProducts();
        // }
        //
        // if (this.id !== undefined) {
        //    // this.fetchProducts(Number(this.id));
        // }
        //
        // if (this.ProductDataSet !== undefined) {
        //     this.fetchProductDataSet(this.ProductDataSet.getDataSetParams());
        // }


    }

}
